/**
 * Footer
 *
 * Erfüllt Hermines a11y-Forderung "Footer mit Kontakt + Social".
 * Bewusst dezent, mit gleichem warmen Dark-Tone wie die obere Hälfte
 * der Seite. Auf der HomePage (overflow: hidden, 100vh) bleibt er
 * unsichtbar; auf allen scrollbaren Inhaltsseiten erscheint er am
 * Seitenende.
 */

import { Link } from 'react-router-dom'
import { useT, STRINGS } from '@/context/LanguageContext'
import { IconMail, IconMapPin, IconNews, IconScroll, IconFacebook } from './FooterIcons'
import './Footer.css'

// Anna's Facebook Professional Page. Alex received only the numeric
// page ID from Anna (she didn't know how to send the vanity URL); the
// numeric form is a stable canonical redirect that Facebook resolves
// to the current vanity name on visit.
const FACEBOOK_PAGE = 'https://www.facebook.com/696069730454678'
const CONTACT_EMAIL = 'anna@sachersantana.com'

export function Footer() {
  const t = useT()
  const year = new Date().getFullYear()
  return (
    <footer className="site-footer">
      <div className="site-footer-grid">
        <div className="site-footer-col site-footer-col-anna">
          <img
            className="site-footer-portrait"
            src="https://api-storage.arkserver.arkturian.com/storage/media/36183?width=160&height=160"
            alt="Anna Sacher Santana"
            loading="lazy"
          />
          <div>
            <h4 className="site-footer-title">Anna Sacher Santana</h4>
            <p className="site-footer-muted">{t(STRINGS.footer.bio)}</p>
            <p className="site-footer-muted site-footer-with-icon">
              <IconMapPin className="site-footer-icon" />
              <span>{t(STRINGS.footer.studio)}</span>
            </p>
          </div>
        </div>

        <div className="site-footer-col">
          <h4 className="site-footer-title">{t(STRINGS.common.contact)}</h4>
          <a className="site-footer-link site-footer-with-icon" href={`mailto:${CONTACT_EMAIL}`}>
            <IconMail className="site-footer-icon" />
            <span>{CONTACT_EMAIL}</span>
          </a>
        </div>

        <div className="site-footer-col">
          <h4 className="site-footer-title">{t(STRINGS.common.media)}</h4>
          {/* YouTube-Kanal-Link ist bewusst entfernt — Anna's Feedback
              "wenn man auf YouTube-Kanal drückt kommen zwei kurze Videos
              und bei Interview und Presse noch mehr" (WhatsApp 26.06.26).
              Die Medien-&-Artikel-Seite bündelt schon 3 eingebettete
              Videos + einen "Weitere Aufnahmen" Link auf ihren Kanal —
              das ist die konsolidierte Seite die Anna wollte. */}
          <Link className="site-footer-link site-footer-with-icon" to="/kuenstlerin/medien-artikel">
            <IconNews className="site-footer-icon" />
            <span>{t(STRINGS.footer.interviewsAndPress)}</span>
          </Link>
          <a
            className="site-footer-link site-footer-with-icon"
            href={FACEBOOK_PAGE}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconFacebook className="site-footer-icon" />
            <span>Facebook</span>
          </a>
        </div>

        <div className="site-footer-col">
          <h4 className="site-footer-title">{t(STRINGS.common.legal)}</h4>
          <Link className="site-footer-link site-footer-with-icon" to="/impressum">
            <IconScroll className="site-footer-icon" />
            <span>{t(STRINGS.common.imprint)}</span>
          </Link>
        </div>
      </div>

      <div className="site-footer-bottom">
        <span>© {year} Anna Sacher Santana</span>
        <span className="site-footer-dot" aria-hidden="true">·</span>
        <span>{t(STRINGS.common.allRightsReserved)}</span>
      </div>
    </footer>
  )
}
